import "./App.css";
import React, { useState, useEffect } from "react";
import MapWithMarkers from "./MapWithMarkers";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInAnonymously,
  GoogleAuthProvider,
  signInWithPopup,
  OAuthProvider,
  getRedirectResult,
  signOut,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import CountDown from "./CountDown";
// import Birthday from "./Birthday";

const firebaseConfig = {
  apiKey: "AIzaSyCacYdt29AwswA4fOjDgi9AbfF3d9L2ZRM",
  authDomain: "swami-birthday-99.firebaseapp.com",
  projectId: "swami-birthday-99",
  storageBucket: "swami-birthday-99.appspot.com",
  messagingSenderId: "738215135767",
  appId: "1:738215135767:web:6d9bb78522919b22dc6a52",
  measurementId: "G-CR9FKQMPK4",
  databaseURL:
    "https://swami-birthday-99-default-rtdb.asia-southeast1.firebasedatabase.app",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const rdb = getDatabase(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export default function App() {
  const [user, setUser] = useState(false);
  // const [hideCurtain, setHideCurtain] = useState(false);

  const signOutUser = async () => {
    try {
      await signOut(auth);
      setUser(null);
    } catch (error) {
      console.log(analytics);
      // Handle error
    }
  };

  const signIn = async (mode = "") => {
    let currentUser, provider;
    try {
      switch (mode) {
        case "yahoo":
          provider = new OAuthProvider("yahoo.com");
          currentUser = await signInWithPopup(auth, provider);
          currentUser = currentUser.user;
          break;
        case "microsoft":
          provider = new OAuthProvider("microsoft.com");
          currentUser = await signInWithPopup(auth, provider);
          currentUser = currentUser.user;
          break;
        case "google":
          provider = new GoogleAuthProvider();
          provider.addScope(
            "https://www.googleapis.com/auth/contacts.readonly"
          );
          currentUser = await signInWithPopup(auth, provider);
          currentUser = currentUser.user;
          break;
        case "anonymous":
          currentUser = await signInAnonymously(auth);
          currentUser = currentUser.user;
          break;
        default:
          currentUser = auth.currentUser;
          break;
      }
      setUser(currentUser);
    } catch (ex) {
      console.log(ex.code, ex.message);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      // openCurtains();
      await getRedirectResult(auth);
      await signIn();
    };
    initialize();
  }, []);

  return (
    <div className="App">
      <header>
        <div className="logo-container">
          <div className="d-flex flex-row justify-content-center align-items-center gap-2">
            {/* <div className="logo-img ">
              <img
                style={{ width: "45px" }}
                src="https://www.sssmediacentre.org/sssct.png"
                alt=""
              />
              <div className="logo-tooltip w-80">
                <a
                  href="https://www.srisathyasai.org"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sri Sathya Sai Central Trust
                </a>
              </div>
            </div> */}
            <div className="logo-img">
              <div className="logo-img-inner">
                <img
                  style={{ width: "45px" }}
                  src="https://www.sssmediacentre.org/755f75139b00a808ae072efc6cdd7ae8.png"
                  alt=""
                />
                <div className="w-80">
                  <a
                    href="https://www.sssmediacentre.org"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="logo-text">Sri Sathya Sai </span>
                    <span className="text-chocolate-gold">
                      Centenary Celebration
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="countdown-container" style={{ padding: "5px 10px" }}>
            <div
              className="countdown"
              style={{ padding: "0px 10px 10px 10px" }}
            >
              <CountDown endAt={"2025-11-23 00:00:00"} />
            </div>
          </div>
        </div>
      </header>
      {user !== false && (
        <MapWithMarkers
          rdb={rdb}
          db={db}
          signIn={signIn}
          signOut={signOutUser}
          state={{ user }}
        />
      )}
    </div>
  );
}
